import produce from 'immer';

import { createKeyInTransform } from 'Lib/persist/transforms';
import type { Action } from 'Lib/reduxType';

import { SET_APPEALS_MODAL_FYI_VIEWED, SET_BAN_POLICY } from 'Store/appeals/constants';
import initialState from 'Store/appeals/initialState';
import type { AppealsState } from 'Store/appeals/types';

export const reducer = produce<AppealsState, [Action]>((draft, action) => {
  switch (action.type) {
    case SET_APPEALS_MODAL_FYI_VIEWED: {
      draft.modalFYIviewedAt = action.payload?.modalFYIviewedAt;
      break;
    }

    case SET_BAN_POLICY: {
      draft.banPolicy = action.payload;
      break;
    }

    default:
      break;
  }
}, initialState);

export const persistConfig = {
  transforms: [createKeyInTransform(['modalFYIviewedAt'])],
  version: 1,
};
